export const IN_REACT_NATIVE = Boolean(window.ReactNativeWebView);

export const EVENTS = {
  FCM_TOKEN_CHANGED: 'fcmtokenchanged',
  USER_LOGGED_IN: 'userloggedin',
  USER_LOGGED_OUT: 'userloggedout',
  SPA_NAVIGATION_STATE_CHANGE: 'spanavigationstatechange',
};
